'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = _interopDefault(require('react'));
var ReactDOM = _interopDefault(require('react-dom'));
var redux = require('redux');
var reactRedux = require('react-redux');
var reactRouterDom = require('react-router-dom');
var history = require('history');
var PropTypes = _interopDefault(require('prop-types'));
var warning = _interopDefault(require('tiny-warning'));
var _$1 = _interopDefault(require('lodash'));

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter =
/*#__PURE__*/
function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter(props) {
    var _this;

    _classCallCheck(this, BrowserRouter);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(BrowserRouter).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "appendDefaultSearch", function (location) {
      if (!location) {
        return location;
      } // 无附加查询参数，直接返回


      var additionalSearch = _this.props.additionalSearch;

      if (!additionalSearch || _.isEmpty(additionalSearch.trim())) {
        return location;
      } // string -> object


      if (typeof location === 'string') {
        location = history.parsePath(location);
      } // 追加查询参数


      var _location = location,
          search = _location.search;

      if (!search || _.isEmpty(search.trim())) {
        return _.assign(location, {
          search: additionalSearch
        });
      } // 滤去空值和已有的查询参数


      var params = [];

      _.forEach(_.split(_.trimStart(additionalSearch, " ?"), "&"), function (item) {
        var keyValue = _.split(item, "=");

        if (keyValue.length === 2) {
          var key = keyValue[0].trim();
          var value = keyValue[1].trim();

          if (value && !_.isEmpty(value.trim()) && search.indexOf("?".concat(key, "=")) < 0 && search.indexOf("&".concat(key, "=")) < 0) {
            params.push(item.trim());
          }
        }
      });

      if (_.isEmpty(params)) {
        return location;
      }

      return _.assign(location, {
        search: "".concat(search, "&").concat(_.join(params, "&"))
      });
    });

    var history$1 = history.createBrowserHistory(props);
    var _createHref = history$1.createHref,
        _push = history$1.push,
        _replace = history$1.replace;
    _this.history = _.assign(history$1, {
      createHref: function createHref(location) {
        return _createHref(_this.appendDefaultSearch(location));
      },
      push: function push(path, state) {
        return _push(_this.appendDefaultSearch(path), state);
      },
      replace: function replace(path, state) {
        return _replace(_this.appendDefaultSearch(path), state);
      }
    });
    return _this;
  }

  _createClass(BrowserRouter, [{
    key: "render",
    value: function render() {
      return React.createElement(reactRouterDom.Router, {
        history: this.history,
        children: this.props.children
      });
    } // 自动追加默认 search

  }]);

  return BrowserRouter;
}(React.Component);

BrowserRouter.propTypes = {
  basename: PropTypes.string,
  children: PropTypes.node,
  forceRefresh: PropTypes.bool,
  getUserConfirmation: PropTypes.func,
  keyLength: PropTypes.number,
  additionalSearch: PropTypes.string
};

BrowserRouter.prototype.componentDidMount = function () {
  warning(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.");
};

var ApiContext = React.createContext();
function withApi(Component) {
  return function WithApi(props) {
    return React.createElement(ApiContext.Consumer, null, function (api) {
      return React.createElement(Component, _extends({}, props, {
        webApi: api
      }));
    });
  };
}

/**
 * Check whether the obj has a method named `name`
 * @param obj
 * @param name
 */

function hasMethod(obj, name) {
  var desc = Object.getOwnPropertyDescriptor(obj, name);
  return !!desc && typeof desc.value === 'function';
}
/**
 * Get the instance method names
 * @param obj
 * @param stop
 */


function getInstanceMethodNames(obj, stop) {
  var array = [];
  var proto = Object.getPrototypeOf(obj);

  while (proto && proto.constructor.name !== 'Object') {
    Object.getOwnPropertyNames(proto).forEach(function (name) {
      if (name !== 'constructor') {
        if (hasMethod(proto, name)) {
          array.push(name);
        }
      }
    });
    proto = Object.getPrototypeOf(proto);
  }

  return array;
}

function transformApiFunction(context, apiFunc, accumulator) {
  return function () {
    var api = apiFunc.apply(context, arguments);

    if (_typeof(api) === 'object') {
      // Treat as Standard Api
      if (typeof api.ajax === 'function') {
        return accumulator(api, arguments);
      }
    }

    return api;
  };
}

function transformApiObject(context, apiObject, accumulator) {
  var enhanced = {};
  var methodNames = getInstanceMethodNames(apiObject);

  var keys = _$1.concat(_$1.keysIn(apiObject), methodNames);

  _$1.forEach(keys, function (key) {
    var api = apiObject[key];

    if (_typeof(api) === 'object') {
      enhanced[key] = transformApiObject(enhanced, api, accumulator);
    } else if (typeof api === 'function') {
      enhanced[key] = transformApiFunction(enhanced, api, accumulator);
    } else {
      enhanced[key] = api;
    }
  });

  return enhanced;
}

function transform(webApi, accumulator) {
  if (typeof webApi.ajax === 'function') {
    return accumulator(webApi);
  } else {
    return transformApiObject(webApi, webApi, accumulator);
  }
}

var HEADER_CONTENT_TYPE = 'Content-Type';
var HEADER_CONTENT_LENGTH = 'Content-Length';
var HEADER_X_REQUESTED_WITH = 'X-Requested-With';
var HEADER_X_CUSTOM_DATA = 'X-Custom-Data';

var MIME_JSON = 'application/json';
var MIME_FORM_URLENCODED = 'application/x-www-form-urlencoded';
var MIME_OCTET_STREAM = 'application/octet-stream';
var MIME_TEXT = 'text/plain';
var MIME_HTML = 'text/html';
function parseContentType(contentType) {
  if (contentType) {
    if (contentType.indexOf(';') > 0) {
      contentType = contentType.substr(0, contentType.indexOf(';'));
    }
  } else {
    contentType = MIME_OCTET_STREAM;
  }

  return contentType;
}

/**
 * 组装查询参数
 * @param params
 * @returns {string}
 */

function queryParams(params) {
  if (typeof params === 'string') {
    return params;
  }

  return Object.keys(params).filter(function (k) {
    return !!params[k];
  }).map(function (k) {
    var value = params[k];

    if (_$1.isArray(value)) {
      return value.map(function (v) {
        return encodeURIComponent(k) + '[]=' + encodeURIComponent(v);
      }).join('&');
    } else {
      return encodeURIComponent(k) + '=' + encodeURIComponent(params[k]);
    }
  }).join('&');
}
/**
 * 创建一个新的 Headers 对象
 * @param init 用于复制的数据，可以是 Headers，也可以是普通的 JSON 对象
 * @returns {Headers}
 */


function newHeaders(init) {
  var headers = new Headers();

  if (init) {
    if (typeof init.entries === 'function') {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = init.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var entry = _step.value;
          headers.set.apply(headers, _toConsumableArray(entry));
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    } else {
      _$1.forEach(init, function (v, k) {
        headers.set(k, v);
      });
    }
  }

  return headers;
}
/**
 * 从响应中解析响应体
 * @param response
 * @param resolve
 * @returns {*}
 */


function parseBody(response, resolve) {
  // 从响应中解析获得 Content-Type，并去除编码信息
  var contentType = parseContentType(response.headers.get(HEADER_CONTENT_TYPE));
  var contentLength = parseInt(response.headers.get(HEADER_CONTENT_LENGTH));

  if (contentLength === 0) {
    resolve && resolve();
    return {
      contentType: contentType
    };
  } // 解析自定义头部


  var customHeader = response.headers.get(HEADER_X_CUSTOM_DATA);

  if (contentType === MIME_JSON) {
    var json = response.json();
    resolve && resolve(json, customHeader, contentType);
    return {
      contentType: contentType,
      json: json,
      customHeader: customHeader
    };
  } else if (contentType === MIME_FORM_URLENCODED) {
    var formData = response.formData();
    resolve && resolve(formData, customHeader, contentType);
    return {
      contentType: contentType,
      formData: formData,
      customHeader: customHeader
    };
  } else if (_$1.startsWith(contentType, 'text/')) {
    var text = response.text();
    resolve && resolve(text, customHeader, contentType);
    return {
      contentType: contentType,
      text: text,
      customHeader: customHeader
    };
  } else {
    var blob = response.blob();
    resolve && resolve(blob, customHeader, contentType);
    return {
      contentType: contentType,
      blob: blob,
      customHeader: customHeader
    };
  }
}
/**
 * 使用响应构造错误信息
 * @param response
 * @param contentType
 * @returns {{code: *, response: *, statusText: (string|string), message: (string|string), contentType: *, status: *}}
 */


function newError(response, contentType) {
  return {
    status: response.status,
    statusText: response.statusText,
    contentType: contentType,
    response: response,
    code: response.status,
    message: response.statusText
  };
}
/**
 * 处理响应，包括在 OK 时对响应体进行正确解析，在其他错误时按需标准化错误内容
 * @param promise
 * @returns {Promise}
 */


function handleResponse(promise) {
  var settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return new Promise(function (resolve, reject) {
    promise.then(function (response) {
      if (response.ok) {
        parseBody(response, function (data, customHeader, contentType) {
          // 可以在每次请求中或通过创建时的 options 设置 parseJsonCode = true, 支持解析格式为 {code, message, data} 的 JSON 响应
          var needParseJsonCode = (_$1.has(settings, 'parseJsonCode') ? settings.parseJsonCode : options.parseJsonCode) || false;

          if (contentType === MIME_JSON && needParseJsonCode) {
            data.then(function (json) {
              var _ref = json || {},
                  code = _ref.code,
                  data = _ref.data;

              if (code === 0) {
                resolve(data, customHeader);
              } else {
                reject(_$1.assign(newError(response, contentType), json));
              }
            }, function () {
              return reject(newError(response, contentType));
            });
          } else {
            resolve(data, customHeader);
          }
        });
      } else {
        var parsed = parseBody(response);
        var error = newError(response, parsed.contentType);

        if (parsed.json) {
          parsed.json.then(function (json) {
            if (json.error) {
              reject(_$1.assign(error, json.error));
            } else {
              reject(_$1.assign(error, json));
            }
          }, function () {
            reject(error);
          });
        } else if (parsed.text) {
          parsed.text.then(function (text) {
            reject(_$1.assign(error, {
              text: text,
              responseText: text
            }));
          }, function () {
            reject(error);
          });
        } else {
          reject(error);
        }
      }
    }, function (e) {
      return {
        code: -1,
        message: typeof e === 'string' ? e : e.message
      };
    });
  });
}
/**
 * 模拟 jQuery.ajax 函数的调用实现
 * @param url
 * @param settings
 * @param options
 * @returns {Promise}
 */


function ajax(url) {
  var settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var init = {};
  var method = init.method = settings.method || 'GET';
  var headers = init.headers = newHeaders(settings.headers); // 往 Header 中添加 X-Requested-With，模拟 XHR

  headers.set(HEADER_X_REQUESTED_WITH, 'XMLHttpRequest');
  var data = settings.data,
      processData = settings.processData,
      contentType = settings.contentType;
  var initContentType = true;

  if (data) {
    // POST & PUT
    if (method === 'POST' || method === 'PUT') {
      // FormData 总是可以识别
      if (data.constructor && data.constructor.name === 'FormData') {
        init.body = data;
        initContentType = false;
      } // 普通对象遵循 processData 的要求
      else if (_typeof(data) === 'object') {
          if (processData === false) {
            var formData = new FormData();

            _$1.forEach(data, function (v, k) {
              formData.set(k, v);
            });

            init.body = formData;
            initContentType = false;
          } // 处理 JSON
          else if (_$1.startsWith(contentType, MIME_JSON) || _$1.startsWith(headers.get(HEADER_CONTENT_TYPE), MIME_JSON)) {
              init.body = JSON.stringify(data);
            } // 处理其他数据类型
            else {
                init.body = queryParams(data);
              }
        } // 其他不处理
        else {
            init.body = data;
          } // 对于非 FormData，设置默认的 Content-Type


      if (initContentType) {
        var _contentType = headers.get(HEADER_CONTENT_TYPE);

        if (!_contentType) {
          headers.set(HEADER_CONTENT_TYPE, MIME_FORM_URLENCODED + '; charset=UTF-8');
        }
      }
    } // GET & etc
    else {
        // if (method === 'HEAD' || method === 'GET' || method === 'DELETE') {
        url += (url.indexOf('?') > 0 ? '&' : '?') + queryParams(data);
      }
  }

  return handleResponse(fetch(url, init), settings, options).then(function (resp, customHeader) {
    if (typeof options.success === 'function') {
      options.success(resp, customHeader);
    }

    return resp;
  }, function (errors) {
    if (typeof options.error === 'function') {
      options.error(errors);
    }

    throw errors;
  });
}
/**
 * 自动将请求体设置为 JSON
 * @param url
 * @param settings
 * @param options
 * @returns {Promise}
 */


function ajaxJson(url) {
  var settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var headers = newHeaders(settings.headers);
  headers.set(HEADER_CONTENT_TYPE, MIME_JSON + '; charset=UTF-8');
  return ajax(url, _$1.defaults({
    headers: headers
  }, settings), options);
}
/**
 * 自动将请求体设置为普通表单
 * @param url
 * @param settings
 * @param options
 * @returns {Promise}
 */


function ajaxForm(url) {
  var settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return ajax(url, settings, options);
}

function addCsrf() {
  var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var csrf = arguments.length > 1 ? arguments[1] : undefined;

  if (csrf) {
    return _$1.merge(settings, {
      headers: _defineProperty({}, csrf.header, csrf.token)
    });
  } else {
    return settings;
  }
}

function addHeaders() {
  var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var headers = arguments.length > 1 ? arguments[1] : undefined;

  if (headers) {
    return _$1.merge(settings, {
      headers: _$1.isFunction(headers) ? headers() : headers
    });
  } else {
    return settings;
  }
}

function enhanceFetch(enhanced, args) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  // 强化 ajax() 函数，并模拟 jQuery.ajax 实现
  enhanced.ajax = function (settings) {
    return ajax(enhanced.url, _$1.assign({
      method: enhanced.method
    }, addCsrf(settings, options.csrf), addHeaders(settings, options.headers)), options);
  };

  enhanced.ajaxJson = function (settings) {
    return ajaxJson(enhanced.url, _$1.assign({
      method: enhanced.method
    }, addCsrf(settings, options.csrf), addHeaders(settings, options.headers)), options);
  };

  enhanced.ajaxForm = function (settings) {
    return ajaxForm(enhanced.url, _$1.assign({
      method: enhanced.method
    }, addCsrf(settings, options.csrf), addHeaders(settings, options.headers)), options);
  };
}

/**
 * Parse the error
 * @param xhr
 * @param textStatus
 * @param errorThrown
 */

function parseError(xhr, textStatus, errorThrown) {
  // Faked error
  if (typeof xhr === 'string') {
    return {
      status: 499,
      statusText: 'Invalid API Method',
      message: xhr
    };
  }

  var parsed = {
    status: xhr.status,
    statusText: textStatus || xhr.statusText || 'Error',
    message: errorThrown || xhr.message
  };

  if (typeof xhr.getResponseHeader !== 'function') {
    return parsed;
  }

  parsed.message = xhr.message || xhr.statusText || "Unknown Exception";
  var contentType = parseContentType(xhr.getResponseHeader(HEADER_CONTENT_TYPE));

  if (contentType === MIME_TEXT) {
    parsed.message = xhr.responseText;
  } else if (contentType === MIME_HTML) ; else if (contentType === MIME_JSON) {
    var json = JSON.parse(xhr.responseText);

    if (json) {
      if (typeof json === 'string') {
        parsed.message = json;
      } else if (_typeof(json) === 'object') {
        if (json.error) {
          _$1.assign(parsed, json.error);
        } else if (json.code && json.message) {
          parsed.status = json.code;
          parsed.statusText = json.codeName;
          parsed.message = json.message;
        } else {
          parsed.message = _$1.flatten(_$1.values(json)).join(",");
        }
      } else if (_$1.isArray(json)) {
        parsed.message = json.join(",");
      } else {
        parsed.message = xhr.responseText;
      }

      parsed.json = json;
    } else {
      parsed.message = xhr.responseText;
    }
  }

  if (parsed.message === '[object Object]') {
    parsed.message = undefined;
  }

  return parsed;
}
/**
 * Prepare to send the ajax request as HTML Form
 * @param settings ajax settings
 */


function prepareForm() {
  var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var data = settings.data;

  if (data instanceof FormData) {
    return _$1.merge(settings, {
      processData: false,
      contentType: false
    });
  } else {
    return _$1.merge(settings, {
      contentType: MIME_FORM_URLENCODED
    });
  }
}
/**
 * Prepare to send the ajax request as JSON
 * @param settings ajax settings
 */


function prepareJson() {
  var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var data = settings.data;

  if (typeof data !== 'string') {
    data = JSON.stringify(data);
  }

  return _$1.merge(settings, {
    contentType: MIME_JSON + '; charset=utf-8',
    dataType: 'json',
    data: data
  });
}

function addCsrf$1() {
  var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var csrf = arguments.length > 1 ? arguments[1] : undefined;

  if (csrf) {
    return _$1.merge(settings, {
      headers: _defineProperty({}, csrf.header, csrf.token)
    });
  } else {
    return settings;
  }
}

function addHeaders$1() {
  var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var headers = arguments.length > 1 ? arguments[1] : undefined;

  if (headers) {
    return _$1.merge(settings, {
      headers: _$1.isFunction(headers) ? headers() : headers
    });
  } else {
    return settings;
  }
}

function enhanceJQuery(enhanced, args) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var originalAjax = enhanced.ajax;

  enhanced.ajax = function (settings) {
    // Wrap with real Promise
    return new Promise(function (resolve, reject) {
      originalAjax(_$1.assign(addCsrf$1(settings, options.csrf), addHeaders$1(settings, options.headers))).then(function (resp, textStatus, jqXHR) {
        var contentType = jqXHR ? parseContentType(jqXHR.getResponseHeader(HEADER_CONTENT_TYPE)) : '';

        if (contentType === MIME_JSON) {
          // 可以在每次请求中或通过创建时的 options 设置 parseJsonCode = true, 支持解析格式为 {code, message, data} 的 JSON 响应
          var needParseJsonCode = (_$1.has(settings, 'parseJsonCode') ? settings.parseJsonCode : options.parseJsonCode) || false;

          if (needParseJsonCode) {
            var _ref = resp || {},
                code = _ref.code,
                message = _ref.message,
                data = _ref.data;

            if (code !== 0) {
              var error = {
                status: code.status,
                statusText: 'Error',
                message: message
              };

              if (typeof options.error === 'function') {
                options.error(error);
              }

              reject(error);
              return;
            }

            resp = data;
          }
        }

        var customHeader = jqXHR && jqXHR.getResponseHeader(HEADER_X_CUSTOM_DATA);

        if (typeof options.success === 'function') {
          options.success(resp, customHeader);
        }

        resolve(resp);
      }, function () {
        var parsed = parseError.apply(void 0, arguments);

        if (typeof options.error === 'function') {
          options.error(parsed);
        }

        reject(parsed);
      });
    });
  };

  enhanced.ajaxForm = function (settings) {
    return enhanced.ajax(prepareForm(settings));
  };

  enhanced.ajaxJson = function (settings) {
    return enhanced.ajax(prepareJson(settings));
  };
}

var FAKE_PROMISE = {
  then: function then() {
    return FAKE_PROMISE;
  },
  catch: function _catch() {
    return FAKE_PROMISE;
  }
};
/**
 * Create a lazy promise to suppress the warning under dispatch
 * @param executor Promise executor
 */

function createLazyPromise(executor) {
  var resolved = false;
  var theError = null;
  var p = null; // create the Promise

  p = new Promise(function (resolve, reject) {
    executor(function (data) {
      resolved = true;
      resolve(data);

      if (p) {
        p.then = p.oldThen;
        p.catch = p.oldCatch;
        p.oldThen = p.oldCatch = undefined;

        if (p.theOnFulfilled) {
          p.theOnFulfilled(data);
        }
      }
    }, function (error) {
      theError = error;

      if (p) {
        if (p.theOnRejected) {
          p.then = p.oldThen;
          p.catch = p.oldCatch;
          p.oldThen = p.oldCatch = undefined;
          p.theOnRejected(error);
        }
      }
    });
  }); // Hack the promise to suppress the exception

  if (!resolved) {
    p.oldThen = p.then;
    p.oldCatch = p.catch;

    p.then = function (onFulfilled, onRejected) {
      return new Promise(function (resolve, reject) {
        if (theError) {
          if (onRejected) {
            resolve(onRejected(theError));
          } else {
            reject(theError);
          }
        } else {
          p.theOnFulfilled = function (value) {
            resolve(onFulfilled(value));
          };

          p.theOnRejected = function (error) {
            if (onRejected) {
              resolve(onRejected(error));
            } else {
              reject(error);
            }
          };
        }
      });
    };

    p.catch = function (onRejected) {
      return new Promise(function (resolve, reject) {
        if (theError) {
          if (onRejected) {
            resolve(onRejected(theError));
          } else {
            reject(theError);
          }
        } else {
          p.theOnRejected = function (error) {
            if (onRejected) {
              resolve(onRejected(error));
            } else {
              reject(error);
            }
          };
        }
      });
    };
  }

  return p;
}

function enhanceRedux(enhanced, args, reduxDispatch) {
  // Dispatch
  enhanced.dispatch = function (actions, settings, success, error, func) {
    var _ref = settings || {},
        payload = _ref.data;

    reduxDispatch({
      type: actions.QUERY,
      args: args,
      params: actions.params,
      payload: payload
    });
    return createLazyPromise(function (resolve, reject) {
      reduxDispatch(function (dispatch, getState) {
        func = func || enhanced.ajax;
        return func.call(enhanced, settings).then(function (resp) {
          var action = success ? success(resp) : null;

          if (!action) {
            action = {
              data: resp
            };
          }

          action = _.assign({
            type: actions.SUCCESS,
            args: args,
            params: actions.params,
            payload: payload
          }, action);
          dispatch(action);
          resolve(resp);
        }, function (parsed) {
          var action = error ? error(parsed) : null;

          if (!action) {
            action = parsed;
          }

          action = _.assign({
            type: actions.ERROR,
            args: args,
            params: actions.params,
            payload: payload
          }, action);
          dispatch(action);
          reject(parsed);
        });
      });
    });
  }; // Dispatch as Form


  enhanced.dispatchForm = function (actions, settings, success, error) {
    return enhanced.dispatch(actions, settings, success, error, enhanced.ajaxForm);
  }; // Dispatch as Json


  enhanced.dispatchJson = function (actions, settings, success, error) {
    return enhanced.dispatch(actions, settings, success, error, enhanced.ajaxJson);
  }; // When


  enhanced.when = function (predicate, otherwise) {
    var chain = {};

    chain.dispatch = function (actions, settings, success, error, func) {
      return createLazyPromise(function (resolve, reject) {
        reduxDispatch(function (dispatch, getState) {
          var state = getState();

          if (predicate(state)) {
            func = func || enhanced.dispatch;
            func.call(enhanced, actions, settings, success, error).then(resolve, reject);
          } else if (typeof otherwise === 'function') {
            try {
              var result = otherwise(state);

              if (result) {
                resolve(result);
              } else {
                resolve(FAKE_PROMISE);
              }
            } catch (e) {
              reject(e);
            }
          } else {
            resolve(FAKE_PROMISE);
          }
        });
      });
    };

    chain.dispatchForm = function (actions, settings, success, error) {
      return chain.dispatch(actions, settings, success, error, enhanced.dispatchForm);
    };

    chain.dispatchJson = function (actions, settings, success, error) {
      return chain.dispatch(actions, settings, success, error, enhanced.dispatchJson);
    };

    return chain;
  };
}

var Enhancer =
/*#__PURE__*/
function () {
  function Enhancer() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Enhancer);

    this.useFetch = typeof options.useFetch === 'undefined' ? !window.jQuery : options.useFetch;
    this.reduxDispatch = options.dispatch;
    this.options = options;
    this.doEnhance = this.doEnhance.bind(this);
  }

  _createClass(Enhancer, [{
    key: "enhance",
    value: function enhance(webApi) {
      return transform(webApi, this.doEnhance);
    }
  }, {
    key: "doEnhance",
    value: function doEnhance(action, args) {
      var enhanced = _$1.clone(action);

      if (this.useFetch && enhanced.url) {
        enhanceFetch(enhanced, args, this.options);
      } else {
        enhanceJQuery(enhanced, args, this.options);
      }

      this.enhanceWebSocket(enhanced, args);

      if (this.reduxDispatch) {
        enhanceRedux(enhanced, args, this.reduxDispatch);
      }

      return enhanced;
    }
  }, {
    key: "enhanceWebSocket",
    value: function enhanceWebSocket(enhanced, args) {
      var _this = this;

      enhanced.webSocket = function (protocols) {
        var url = enhanced.webSocketURL ? enhanced.webSocketURL() : action.url.replace(/http(s?):(.*)/, 'ws$1:$2');
        return _this.webSocket(url, protocols);
      };
    }
    /**
     * 创建 WebSocket 连接
     * @param url
     * @param protocols
     * @returns {WebSocket}
     */

  }, {
    key: "webSocket",
    value: function webSocket(url, protocols) {
      // return new WebSocket(
      //   url + (url.indexOf('?') > 0 ? '&' : '?') + HEADER_AUTHORIZATION + '=' + encodeURIComponent("Bearer " + this.authToken),
      //   protocols
      // );
      return new WebSocket(url, protocols);
    }
  }]);

  return Enhancer;
}();
/**
 * 强化 webApi 对象
 * @param webApi
 * @param options
 */


function enhanceApi(webApi, options) {
  return new Enhancer(options).enhance(webApi);
}

var AppContainer =
/*#__PURE__*/
function (_React$Component) {
  _inherits(AppContainer, _React$Component);

  function AppContainer() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, AppContainer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(AppContainer)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {});

    return _this;
  }

  _createClass(AppContainer, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        webApi: this.state.webApi
      };
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(ApiContext.Provider, {
        value: this.state.webApi
      }, this.props.children);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var store = props.store,
          dispatch = props.dispatch,
          webApiClass = props.webApiClass,
          options = props.options;

      if (!state || webApiClass !== state.webApiClass || options !== state.options) {
        if (webApiClass) {
          return {
            webApiClass: webApiClass,
            options: options,
            webApi: enhanceApi(new webApiClass(), _.assign({
              dispatch: dispatch || store.dispatch
            }, options))
          };
        } else {
          return {
            webApiClass: webApiClass,
            options: options,
            webApi: undefined
          };
        }
      }

      return null;
    }
  }]);

  return AppContainer;
}(React.Component);

_defineProperty(AppContainer, "propTypes", {
  store: PropTypes.object,
  dispatch: PropTypes.func,
  webApiClass: PropTypes.func,
  options: PropTypes.object
});

_defineProperty(AppContainer, "childContextTypes", {
  webApi: PropTypes.object
});

function resolveDomElement(domElement) {
  if (domElement instanceof Element) ; else if (typeof domElement === 'string') {
    domElement = document.querySelector(domElement);
  } else {
    domElement = document.getElementById('root') || document.getElementById('page');
  }

  if (!domElement) {
    throw new Error('Unable to find domElement to render into.');
  }

  return domElement;
}

function getPageProps(domElement) {
  var pageProps = window.pageProps || {}; // Merge props from domElement

  if (domElement) {
    domElement = resolveDomElement(domElement);

    if (domElement.dataset) {
      pageProps = Object.assign({}, domElement.dataset, pageProps);
    }
  }

  var basename = pageProps.basename || pageProps.basePath || pageProps.baseUrl;

  if (basename) {
    if (basename !== '/' && basename.endsWith('/')) {
      basename = pageProps.basename = basename.substr(0, basename.length - 1);
    } else {
      pageProps.basename = basename;
    }
  }

  return pageProps;
}

var ReduxContext =
/*#__PURE__*/
function () {
  _createClass(ReduxContext, null, [{
    key: "forDOM",
    value: function forDOM(domElement) {
      return new ReduxContext(domElement);
    }
  }]);

  function ReduxContext(domElement) {
    _classCallCheck(this, ReduxContext);

    this.domElement = resolveDomElement(domElement);
    this.defaultProps = getPageProps(this.domElement);
  }

  _createClass(ReduxContext, [{
    key: "configureStore",
    value: function configureStore(reducer, initialState) {
      var composeEnhancers = (typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({// Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
      }) : redux.compose;

      for (var _len = arguments.length, middlewares = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        middlewares[_key - 2] = arguments[_key];
      }

      var enhancer = composeEnhancers(redux.applyMiddleware.apply(void 0, [thunk].concat(middlewares)) // other store enhancers if any
      );
      this.store = redux.createStore(typeof reducer === 'function' ? reducer : redux.combineReducers(reducer), initialState || undefined, enhancer);
      return this;
    }
  }, {
    key: "ensureStore",
    value: function ensureStore() {
      if (!this.store) {
        throw new Error('No redux store has been configured.');
      }

      return this.store;
    }
  }, {
    key: "replaceReducer",
    value: function replaceReducer(reducers) {
      this.ensureStore();
      this.store.replaceReducer(reducers);
    }
  }, {
    key: "render",
    value: function render(ReactElement, props, options) {
      var _this = this;

      this.ensureStore();

      var _Object$assign = Object.assign({
        basename: '/'
      }, this.defaultProps, props),
          webApiClass = _Object$assign.webApiClass,
          headers = _Object$assign.headers,
          csrf = _Object$assign.csrf,
          additionalSearch = _Object$assign.additionalSearch,
          elProps = _objectWithoutProperties(_Object$assign, ["webApiClass", "headers", "csrf", "additionalSearch"]);

      var newOptions = _.assign({
        csrf: csrf,
        headers: headers
      }, options);

      ReactDOM.render(React.createElement(reactRedux.Provider, {
        store: this.store
      }, React.createElement(BrowserRouter, {
        basename: this.defaultProps.basename === '/' ? undefined : this.defaultProps.basename,
        additionalSearch: additionalSearch
      }, React.createElement(reactRouterDom.Route, {
        path: "/",
        render: function render(routeProps) {
          if (webApiClass) {
            return React.createElement(AppContainer, {
              store: _this.store,
              webApiClass: webApiClass,
              options: newOptions
            }, React.createElement(ReactElement, _extends({}, routeProps, elProps)));
          } else {
            return React.createElement(ReactElement, _extends({}, routeProps, elProps));
          }
        }
      }))), this.domElement);
      return this;
    }
  }]);

  return ReduxContext;
}();

var ActionGroup =
/*#__PURE__*/
function () {
  function ActionGroup(name) {
    var _this = this;

    _classCallCheck(this, ActionGroup);

    this._name = name;
    var prefix = this._name + '.';

    for (var _len = arguments.length, ops = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      ops[_key - 1] = arguments[_key];
    }

    _$1.forEach(ops, function (op) {
      return _this[op] = prefix + op;
    });
  }

  _createClass(ActionGroup, [{
    key: "clone",
    value: function clone() {
      return _$1.assign(new ActionGroup(this._name), this);
    }
  }, {
    key: "extend",
    value: function extend() {
      for (var _len2 = arguments.length, ops = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        ops[_key2] = arguments[_key2];
      }

      if (ops.length === 0) {
        return this;
      }

      var cloned = this.clone();
      var prefix = this._name + '.';

      _$1.forEach(ops, function (op) {
        return cloned[op] = prefix + op;
      });

      return cloned;
    }
  }, {
    key: "bind",
    value: function bind(params) {
      if (params) {
        var cloned = this.clone();
        var clonedParams = cloned.params = {};

        _$1.assign(clonedParams, params);

        return cloned;
      } else {
        return this;
      }
    }
  }]);

  return ActionGroup;
}();

function makeActionGroup(name) {
  for (var _len3 = arguments.length, ops = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    ops[_key3 - 1] = arguments[_key3];
  }

  return _construct(ActionGroup, [name].concat(ops));
}
var INIT = 'INIT';
var QUERY = 'QUERY';
var SUCCESS = 'SUCCESS';
var ERROR = 'ERROR';
function makeAjaxAction(name) {
  for (var _len4 = arguments.length, ops = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    ops[_key4 - 1] = arguments[_key4];
  }

  return _construct(ActionGroup, [name, INIT, QUERY, SUCCESS, ERROR].concat(ops));
}
var BEGIN = 'BEGIN';
var UPDATE = 'UPDATE';
var COMMIT = 'COMMIT';
var CANCEL = 'CANCEL';
function makeTxAction(name) {
  for (var _len5 = arguments.length, ops = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
    ops[_key5 - 1] = arguments[_key5];
  }

  return _construct(ActionGroup, [name, BEGIN, UPDATE, COMMIT, CANCEL].concat(ops));
}

var ReduxContext$1 = ReduxContext;

exports.ApiContext = ApiContext;
exports.BEGIN = BEGIN;
exports.CANCEL = CANCEL;
exports.COMMIT = COMMIT;
exports.ERROR = ERROR;
exports.INIT = INIT;
exports.QUERY = QUERY;
exports.ReduxContext = ReduxContext$1;
exports.SUCCESS = SUCCESS;
exports.UPDATE = UPDATE;
exports.makeActionGroup = makeActionGroup;
exports.makeAjaxAction = makeAjaxAction;
exports.makeTxAction = makeTxAction;
exports.withApi = withApi;
